import { buildColumnTree } from '@/features/sliced-form/utils/build-column-tree'
import type { GroupNode } from '@/types/column-catalog'
import { HISTORY_COLUMN_CATALOG, HISTORY_COLUMN_CATALOG_WITH_PATTERNS } from './history-column-defs'

// The catalog is large (thousands of generated columns), so build once at module
// load and share both halves — callers that need labels shouldn't re-walk it.
const { tree, columnMap } = buildColumnTree(HISTORY_COLUMN_CATALOG)
export const HISTORY_TREE = tree
export const HISTORY_COLUMN_MAP = columnMap

// The Similar pattern tree is only needed while its flag is on (internal users),
// so it is built on first use rather than doubling the module-load walk.
let treeWithPatterns: Record<string, GroupNode> | null = null

/** HISTORY_TREE plus the Similar pattern column. Built once, on first call. */
export function getHistoryTreeWithPatterns(): Record<string, GroupNode> {
  treeWithPatterns ??= buildColumnTree(HISTORY_COLUMN_CATALOG_WITH_PATTERNS).tree
  return treeWithPatterns
}
